import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as DeleteIcon } from "../../assets/bin2.svg";
import { ReactComponent as ConfirmIcon } from "../../assets/waiting-for-approval.svg";
import { labelOfCompanyType, labelOfIndustry } from "../../util/labelOf";

import { Modal } from "antd";

// date fns
import formatDistanceToNow from "date-fns/formatDistanceToNow";

import { deleteOrganization } from "../../store/organizations/actions";

const OrganizationDetails = ({ organization, parentCompany }) => {
  const dispatchito = useDispatch();
  const user = useSelector(state => state.user);

  const { confirm } = Modal;
  const deleteConfirm = itemName => {
    confirm({
      title: "Delete Confirmation",
      icon: <ConfirmIcon />,
      content: `Are you sure you want to delete the organization ${itemName}?`,
      okText: "Confirm",
      cancelText: "Close",
      onOk() {
        handleClick();
      },
    });
  };

  //handlers
  const handleClick = async () => {
    if (!user) {
      return;
    }
    dispatchito(deleteOrganization(organization._id, user));
  };

  return (
    <div className="organization-details">
      <div style={{ cursor: "default" }}>
        <table>
          <thead>
            <tr>
              <th colSpan={2}>
                <div>
                  <span>{organization.customerName}</span>
                  {user && user.organization !== organization._id && (
                    <span
                      id={`delete-organization-${organization._id}`}
                      className="material-symbols-outlined"
                      onClick={() => deleteConfirm(organization.customerName)}
                    >
                      <DeleteIcon style={{ padding: "0" }} />
                    </span>
                  )}
                  {/* <DeleteIcon/> */}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Country:</strong>
              </td>
              <td>{organization.country ? organization.country : "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>Fiscal End Date:&nbsp;&nbsp;</strong>
              </td>
              {/* <td>{format(new Date(organization.fiscalEndDate), "MMMM dd")}</td> */}
              <td>{organization.fiscalEndDate}</td>
            </tr>
            <tr>
              <td>
                <strong>Tax ID:</strong>
              </td>
              <td>{organization.taxId}</td>
            </tr>
            {/* <tr>
              <td>
                <strong>Parent Company:&nbsp;&nbsp;&nbsp;&nbsp;</strong>
              </td>
              <td>{organization.parentCompany}</td>
            </tr> */}
            <tr>
              <td>
                <strong>Company Size:</strong>
              </td>
              <td>{organization?.size ?? "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>
                  Part of Group of Companies:&nbsp;&nbsp;&nbsp;&nbsp;
                </strong>
              </td>
              <td>
                {organization.isPartOfGroup
                  ? organization?.parentCompany
                    ? "Subsidiary"
                    : "Mother Company"
                  : "N/A"}
                {parentCompany && ` of ${parentCompany}`}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Company Type:</strong>
              </td>
              <td>{labelOfCompanyType(organization.companyType)}</td>
            </tr>
            <tr>
              <td>
                <strong>Industries:</strong>
              </td>
              <td>
                <ul
                  style={{
                    display: "inline-block",
                    listStyle: "none"
                  }}
                >
                  {organization?.industries
                    ? organization.industries.map((industry, index, arr) => (
                        <li
                          style={{ display: "inline", padding: 0 }}
                          key={industry}
                        >
                          {`${labelOfIndustry(industry)}${
                            index + 1 === arr.length ? "." : ", "
                          }`}
                        </li>
                      ))
                    : "-"}
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Regulated:</strong>
              </td>
              <td>{organization.isRegulated ? "Yes" : "No"}</td>
            </tr>
            <tr>
              <td>
                <strong>Is Listed:</strong>
              </td>
              <td>{organization.isListed ? "Yes" : "No"}</td>
            </tr>
            {organization.isListed && (
              <>
                <tr>
                  <td>
                    <strong>Capitalization:</strong>
                  </td>
                  <td>{organization.capitalization ?? "-"}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Stocks Exchange:</strong>
                  </td>
                  <td>{organization.stocksExchange}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Under Supervision:</strong>
                  </td>
                  <td>{organization.underSupervision ? "Yes" : "No"}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Suspended:</strong>
                  </td>
                  <td>{organization.suspended ? "Yes" : "No"}</td>
                </tr>
              </>
            )}
            <tr>
              <td>
                <strong>Number of Employees:</strong>
              </td>
              <td>{organization.numberOfEmployees ?? "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>Turnover (in {"\u20AC"}):</strong>
              </td>
              <td>
                {organization !== null &&
                organization.turnover &&
                organization.turnover["$numberDecimal"] !== null
                  ? new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR"
                    }).format(organization.turnover["$numberDecimal"])
                  : "-"}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Total Assets (in {"\u20AC"}):</strong>
              </td>
              <td>
                {organization !== null &&
                organization.totalAssets &&
                organization.totalAssets["$numberDecimal"] !== null
                  ? new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR"
                    }).format(organization.totalAssets["$numberDecimal"])
                  : "-"}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Balance Sheet (in {"\u20AC"}):</strong>
              </td>
              <td>
                {organization !== null &&
                organization.balanceSheet &&
                organization.balanceSheet["$numberDecimal"] !== null
                  ? new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR"
                    }).format(organization.balanceSheet["$numberDecimal"])
                  : "-"}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="2">
                <p>
                  {formatDistanceToNow(new Date(organization.createdAt), {
                    addSuffix: true
                  })}
                </p>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <Modal></Modal>
    </div>
  );
};

export default OrganizationDetails;
